import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";

// Configuración de Firebase (ya la tienes correcta)
const firebaseConfig = {
    apiKey: "AIzaSyBC0vyPTJ7nRVp9EdY6VNu3cS1LJogZob4",
    authDomain: "notificaciones-app-b383b.firebaseapp.com",
    projectId: "notificaciones-app-b383b",
    storageBucket: "notificaciones-app-b383b.firebasestorage.app",
    messagingSenderId: "109298966321",
    appId: "1:109298966321:web:591ff65305c33697f2da10",
    measurementId: "G-TNQ9RGVV6Z",
};

// Inicializar Firebase (solo una vez)
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}


// Inicializar el servicio de mensajería y login
// const messaging = firebase.messaging();
let messaging = null;
try {
    messaging = firebase.messaging();
} catch (e) {
    console.warn("Firebase Messaging no está disponible:", e);
}
const auth = firebase.auth();


/**
 * Solicita permiso al usuario y obtiene el token FCM
 */
export const requestPermissionAndGetToken = async () => {
    try {
        await Notification.requestPermission();
        if (Notification.permission === 'granted') {
            const token = await messaging.getToken();
            console.log('Token FCM:', token);
            return token;
        } else {
            console.warn('Permiso de notificación no otorgado');
        }
    } catch (error) {
        console.error('Error al obtener el token FCM:', error);
    }
};

/**
 * Escucha mensajes en primer plano (cuando la app está abierta)
 */
export const onMessageListener = () =>
    new Promise((resolve) => {
        messaging.onMessage((payload) => {
            console.log('Mensaje recibido en primer plano:', payload);
            resolve(payload);
        });
    }
);

export const signInAnonymouslyToFirebase = async () => {
    try {
        const result = await auth.signInAnonymously();
        // console.log("Usuario anónimo autenticado en Firebase:", result.user);
        return result.user;
    } catch (error) {
        console.error("Error al autenticar anónimamente:", error);
    }
};

export { firebase, auth, messaging };
export default messaging;
